export default "__VITE_ASSET__BFFGngAk__"